<template>
  <div class="prm-list" v-loading="pageloading">
    <main-head>
      <template v-slot:pageName>
        {{ $t("page.todoList") }}
      </template>
      <!-- <template v-slot:headBtn>
        <el-button type="primary" v-if="isChannelRole === true&&
          !btnSet.includes('btn_prm_create')" size="medium" @click="toAdd"
        >
          {{ $t('page.addProject') }}
        </el-button>
      </template> -->
    </main-head>
    <main-content>
      <template v-slot:contentArea>
        <div class="form">
          <el-form ref="form" :model="form" label-width="185px">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item :label="$t('page.prmList.projectName')">
                  <el-input v-model="form.projectName" :placeholder="$t('message.needProjectName')" maxlength="256" @blur="getList(form.projectName,'projectName')" />
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="!isChannelRole">
                <el-form-item :label="$t('page.prmList.partnerName')">
                  <el-input v-model="form.partnerName" :placeholder="$t('message.needPartnerName')" maxlength="256" @blur="getList(form.partnerName,'partnerName')" />
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="!isChannelRole">
                <el-form-item :label="$t('page.prmList.country')">
                  <el-select style="width: 100%" v-model="form.nation" clearable filterable
                             :placeholder="$t('message.select')"
                  >
                    <el-option v-for="item in allCountries"
                               :value="item.areaCode"
                               :key="item.areaCode"
                               :label="item.areaName"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('page.prmList.ruijieSaleName')">
                  <el-input v-model="form.ruijieSaleName" :placeholder="$t('message.needRuijieSaleName1')" maxlength="256" @blur="getList(form.ruijieSaleName,'ruijieSaleName')" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('page.prmList.approvalState')">
                  <el-select v-model="form.approvalstate" clearable filterable
                             :placeholder="$t('message.select')"
                  >
                    <el-option
                      v-for="item in stepList"
                      :key="item.stepId"
                      :label="item.stepName"
                      :value="item.stepId"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="20" style="text-align: center;">
                <el-button v-if="!btnSet.includes('btn_prm_search')" type="primary" size="medium" class="submit" @click="search" plain>{{ $t("common.search") }}</el-button>
                <el-button v-if="!btnSet.includes('btn_prm_search')" class="cancle" size="medium" plain @click="registe">{{ $t("common.reset") }}</el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="table">
          <el-table :data="tabledata" border style="width: 100%;font-size: 14px">
            <el-table-column prop="projectName" align="center" :label="$t('page.prmList.projectName')"
                             :render-header="fullHeader" show-overflow-tooltip
            />
            <el-table-column prop="partnerName" align="center" :label="$t('page.prmList.partnerName')"
                             :render-header="fullHeader" show-overflow-tooltip v-if="!isChannelRole"
            />
            <el-table-column prop="areaName" align="center" :render-header="fullHeader" v-if="!isChannelRole"
                             :label="$t('page.prmList.country')" width="120px"
            />
            <el-table-column prop="ruijieSaleName" align="center" :label="$t('page.prmList.ruijieSaleName')"
                             :render-header="fullHeader" show-overflow-tooltip
            />
            <el-table-column prop="createUserName" align="center" :label="$t('page.prmList.applicant')"
                             :render-header="fullHeader" show-overflow-tooltip v-if="!isChannelRole"
            />
            <el-table-column prop="createTime" align="center" :label="$t('page.prmList.submitTime')"
                             :render-header="fullHeader" show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ parseTime(scope.row.createTime,"{y}-{m}-{d}") }}
              </template>
            </el-table-column>
            <el-table-column prop="stepName" align="center" :label="$t('page.prmList.approvalState')"
                             :render-header="fullHeader" show-overflow-tooltip
            />
            <el-table-column prop="projectStatusValue" align="center" :label="$t('page.prmList.prmState')"
                             :render-header="fullHeader" show-overflow-tooltip
            />
            <el-table-column prop="date" align="center" :label="$t('message.operation')" width="220px">
              <template slot-scope="scope">
                <el-button type="text" size="medium" @click="goviewpage(scope.row)">{{ $t("common.view") }}</el-button>
                <el-button type="text" size="medium" v-if="scope.row.canAudit!=null &&scope.row.canAudit" @click="goauditpage(scope.row)">{{ $t("common.audit") }}</el-button>
                <el-button type="text" size="medium" v-if="scope.row.canEdit!=null &&scope.row.canEdit" @click="goeditpage(scope.row)">{{ $t("common.edit") }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="paging" style="text-align: right;margin-top: 20px">
            <el-pagination background
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page.sync="page.currentPage"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="page.pagesize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="page.total"
            />
          </div>
        </div>
        <div class="clear" />
      </template>
    </main-content>
  </div>
</template>

<script>
import API from '../../API';
import { formate } from '../../libs/mixin';
import mainHead from '../component/mainHead';
import mainContent from '../component/mainContent';
import { merge } from '../../libs/util';
import store from '../../store';
export default {
  name: 'PrmTodoList',
  mixins: [formate],
  data () {
    return {
      tabledata: [],
      pageloading: false,
      page: {
        currentPage: 1,
        pagesize: 20,
        total: 0
      },
      form: {
        projectName: '',
        partnerName: '',
        ruijieSaleName: '',
        nation: '',
        approvalstate: ''
      },
      stepList: [],
      allCountries: [],
      btnSet: [],
      isChannelRole: false
    };
  },
  components: {
    mainHead,
    mainContent
  },
  methods: {
    getList (value, values) {
      this.form[values] = value.trim();
    },
    toAdd () {
      this.$router.push({ name: 'prmNew' });
    },
    init () {
      API.getAllCountries(this.$i18n.locale).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.allCountries = json.data;
        }
      }).catch((e) => {
        console.log(e);
      });
      API.getAllSteps(this.$i18n.locale).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.stepList = json.data;
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    search () {
      this.pageloading = true;
      let params = {
        pageNum: this.page.currentPage,
        pageSize: this.page.pagesize,
        projectName: this.form.projectName,
        partnerName: this.form.partnerName,
        ruijieSaleName: this.form.ruijieSaleName,
        areaCode: this.form.nation,
        stepId: this.form.approvalstate,
        language: this.$i18n.locale
      };
      API.getTodoList(params).then((res) => {
        this.pageloading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tabledata = json.data.list;
          this.page.total = json.data.total;
        }
      }).catch((ex) => {
        this.pageloading = false;
      });
    },
    handleSizeChange (val) {
      this.page.pagesize = val;
      this.search();
    },
    handleCurrentChange (val) {
      this.page.currentPage = val;
      this.search();
    },
    fullHeader (h, { column }) {
      if (column.label) {
        return (h('el-tooltip', {
          attrs: {
            class: 'item',
            effect: 'dark',
            content: column.label,
            placement: 'bottom'
          }
        }, [ h('span', [column.label]) ]));
      }
    },
    goviewpage (row) {
      let query = merge(this.$route.query, {
        objectId: row.id
      });
      this.$router.push({
        name: 'prmDtl',
        query: query
      });
    },
    goauditpage (row) {
      let query = merge(this.$route.query, {
        objectId: row.id
      });
      this.$router.push({
        name: 'prmAudit',
        query: query
      });
    },
    goeditpage (row) {
      let query = merge(this.$route.query, {
        objectId: row.id
      });
      this.$router.push({
        name: 'prmEdit',
        query: query
      });
    },
    registe () {
      this.form = {
        projectName: '',
        partnerName: '',
        ruijieSaleName: '',
        nation: '',
        approvalstate: ''
      };
      this.page = {
        currentPage: 1,
        pagesize: 20,
        total: 0
      };
      this.search();
    },
    getCurUserRole () {
      API.getCurUserRole().then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.isChannelRole = json.data;
        }
      }).catch(e => {
        console.log(e);
      });
    }
  },
  mounted () {
    this.btnSet = store.state.UserBtnPermissionsData || [];
    this.init();
    this.search();
    this.getCurUserRole();
  }
};
</script>

<style lang="scss">
.prm-list{
  .form{
    .el-form-item__label{
      text-align: left;
    }
  }
  .table{
    margin-top: 10px;
  }
  .paging{
    margin-top: 20px;
    float: right;
  }
  .clear{
    clear: both;
  }
  .el-select{
    width: 100%;
  }
}
</style>
